import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  testimonialListLoading: false,
  testimonialListSuccess: null,
  testimonialListError: '',
  testimonialDetailsLoading: false,
  testimonialDetailsSuccess: null,
  testimonialDetailsError: '',
  getTestimonialLoading: false,
  getTestimonialSuccess: null,
  getTestimonialError: '',
}

export const testimonialSlice = createSlice({
  name: 'testimonials',
  initialState,
  reducers: {
    setTestimonialListLoading: (state, action) => {
      state.testimonialListLoading = true;
      state.testimonialListSuccess = null;
      state.testimonialListError = '';
    },
    setTestimonialListSuccess: (state, action) => {
      state.testimonialListLoading = false;
      state.testimonialListSuccess = action.payload;
      state.testimonialListError = '';
    },
    setTestimonialListError: (state, action) => {
      state.testimonialListLoading = false;
      state.testimonialListSuccess = null;
      state.testimonialListError = action.payload;
    },
    setTestimonialDetailsLoading: (state, action) => {
      state.testimonialDetailsLoading = true;
      state.testimonialDetailsSuccess = null;
      state.testimonialDetailsError = '';
    },
    setTestimonialDetailsSuccess: (state, action) => {
      state.testimonialDetailsLoading = false;
      state.testimonialDetailsSuccess = action.payload;
      state.testimonialDetailsError = '';
    },
    setTestimonialDetailsError: (state, action) => {
      state.testimonialDetailsLoading = false;
      state.testimonialDetailsSuccess = null;
      state.testimonialDetailsError = action.payload;
    },
    resetTestimonialsData:(state)=>{
      state.testimonialDetailsLoading = false;
      state.testimonialDetailsSuccess = null;
      state.testimonialDetailsError = '';
    },
    setGetTestimonialLoading: (state) => {
      state.getTestimonialLoading = true;
      state.getTestimonialSuccess = null;
      state.getTestimonialError = "";
    },
    setGetTestimonialSuccess: (state, action) => {
      state.getTestimonialLoading = false;
      state.getTestimonialSuccess = action.payload;
      state.getTestimonialError = '';
    },
    setGetTestimonialError: (state, action) => {
      state.getTestimonialLoading = false;
      state.getTestimonialSuccess = null;
      state.getTestimonialError = action.payload;
    },
    setCreateTestimonialLoading: (state) => {
      state.createTestimonialLoading = true;
      state.createTestimonialSuccess = null;
      state.createTestimonialError = '';
    },
    setCreateTestimonialSuccess: (state, action) => {
      state.createTestimonialLoading = false;
      state.createTestimonialSuccess = action.payload;
      state.createTestimonialError = '';
    },
    setCreateTestimonialError: (state, action) => {
      state.createTestimonialLoading = false;
      state.createTestimonialSuccess = null;
      state.createTestimonialError = action.payload;
    },
    resetCreateTestimonial: (state) => {
      state.createTestimonialLoading = false;
      state.createTestimonialSuccess = null;
      state.createTestimonialError = '';
      state.getTestimonialLoading = false;
      state.getTestimonialSuccess = null;
      state.getTestimonialError = '';
    },
    resetAllTestimonials: (state) => {
      state.allTestimonialsLoading = false;
      state.allTestimonialsSuccess = null;
      state.allTestimonialsError = '';
    }
  },
})

// Action creators are generated for each case reducer function
export const { resetAllTestimonials, resetCreateTestimonial, setTestimonialDetailsLoading, setTestimonialDetailsSuccess, setTestimonialDetailsError, setTestimonialListLoading, setTestimonialListSuccess, setTestimonialListError, resetTestimonialsData, setGetTestimonialLoading, setGetTestimonialSuccess, setGetTestimonialError, setCreateTestimonialError, setCreateTestimonialSuccess, setCreateTestimonialLoading } = testimonialSlice.actions

export default testimonialSlice.reducer;